import { useState, createContext, useContext} from "react";
import {LANGS } from "../components/constants.js";

const SharedLangContext = createContext();

export const SharedLangProvider = ({ children }) => {
    const [sharedLang, setSharedLang] = useState(LANGS.JAPANESE);

    return (
        <SharedLangContext.Provider value={{ sharedLang , setSharedLang }}>
            {children}
        </SharedLangContext.Provider>
    );
};

export const useSharedLang = () => {
    return useContext(SharedLangContext);
};